import { render, staticRenderFns } from "./FixWells.vue?vue&type=template&id=6870d021"
import script from "./FixWells.vue?vue&type=script&lang=js"
export * from "./FixWells.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports